import React from 'react';
import { Button, Content, Modal, ModalBody, ModalFooter, ModalHeader } from '@patternfly/react-core';

interface CertificateActionComingSoonModalProps {
  actionLabel: string | null;
  onClose: () => void;
}

function CertificateActionComingSoonModal({ actionLabel, onClose }: CertificateActionComingSoonModalProps) {
  const isOpen = actionLabel !== null;
  const title = actionLabel !== null ? `${actionLabel} — coming soon` : '';

  return (
    <Modal variant="small" isOpen={isOpen} onClose={onClose} aria-label="Action coming soon">
      <ModalHeader title={title} />
      <ModalBody>
        <Content>This action is not available yet. We&apos;re working on it.</Content>
      </ModalBody>
      <ModalFooter>
        <Button variant="primary" onClick={onClose}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default CertificateActionComingSoonModal;
